<template>
<div id="stadistics">
    <div class="my-5">
        <h2 class="col-12 title-h3">Resumen de Ausentismos</h2>
        <div v-if="!justStadistics" class="cards my-5 d-flex">
            <div class="col-3 card-v2 with-border text-formatting-v2 p-3 d-flex justify-content-start ml-4">
                <img 
                    style="position: relative; top: -15px;"
                    class="ml-1" 
                    width="30px" 
                    src="@/assets/images/icons/ht_icon_timelapse_line.svg" />
                <div class="ml-3">
                    <p>
                        Horas de ausencia
                    </p>
                    <h2 class="text-formatting-v2 h2-v2">
                        {{time.hours}} Horas
                    </h2>
                </div>
            </div>
            <div class="col-3 card-v2 with-border text-formatting-v2 p-3 d-flex justify-content-start ml-4">
                <img 
                    style="position: relative; top: -15px; "
                    class="ml-1" 
                    width="30px" 
                    src="@/assets/images/icons/ht_icon_calendar_line.svg" />
                <div class="ml-3">
                    <p>
                        Días perdidos de ausencias 
                    </p>  
                    <h2 class="text-formatting-v2 h2-v2">
                        {{time.days}} días
                    </h2>
                </div>
            </div>
        </div>
    </div>
    <b-row>
        <!-- Cargos/Escenarios --Bolsas de apoyo -->
        <b-col cols="12" sm="3">
            <div v-for="(item,index) in menuStadistics" 
                    :key="index" 
                    class="d-flex col-12 p-0">
                    <div class="item col-lg-12 col-sm-6" 
                        @click="changeStadistics(item),selectItem(index)" 
                        :class="(item.class? 'itemSelect':'')">
                        <h3 class="text-formatting-v2">
                            {{item.name}}
                        </h3>
                    </div>
                </div>
        </b-col>
        <!-- end -->

        <!-- Estadisticas -->
        <b-col cols="6" sm="5">
            <PieChart :chartData="chartData" />
        </b-col>
        <!-- end -->

        <!-- Tabla  -->
        <b-col cols="12" sm="3" style="height:450px;overflow: auto;">
            <h3 class="mb-4 font-weight-bold">
                {{nameStadistcs}}:
            </h3>
            <div v-if="dataEstadistics[0]">
                <div v-for="(item,index) in dataEstadistics" 
                    :key="item.id" 
                    class="col-12 p-0" >
                <div class="col-12 d-flex align-items-center border-bottom my-2" >
                    <h3 class="font-weight-bold m-0 mr-3">
                        {{item.percentage}}%
                    </h3>
                    <div 
                        class="rounded-circle m-0 mr-3" 
                        :style="`height:15px;width:15px;background-color:${stadisticsColors[index]}`">
                    </div>
                    <p class="m-0">{{item.name}}</p>
                </div>
            </div>
            </div>
            <div v-else>
                <p>
                    No hay registro de información
                </p>
            </div>
        </b-col>
        <!-- en -->

        <div class="col-12 my-5 d-flex align-items-center">
            
            <!-- Cargos/Escenarios --Bolsas de apoyo -->
            <!-- <div class="col-md-4 col-sm-12">
                <div v-for="(item,index) in menuStadistics" 
                    :key="index" 
                    class="d-flex col-12 p-0">
                    <div class="item col-lg-12 col-sm-6" 
                        @click="changeStadistics(item),selectItem(index)" 
                        :class="(item.class? 'itemSelect':'')">
                        <h3 class="text-formatting-v2">
                            {{item.name}}
                        </h3>
                    </div>
                </div>
            </div> -->

            <!-- Estadisticas -->
            <!--<div class="col-md-4 col-sm-12">
                <PieChart
                    class="col-12 col-ms"
                    :chart-data="chartData" />
            </div> -->

            <!-- Tabla  -->
            <!-- <div class="col-md-4 col-sm-12" style="height:250px;overflow: auto;">
                <h3 class="mb-4 font-weight-bold">
                    {{nameStadistcs}}:
                </h3>
                <div v-if="dataEstadistics[0]">
                    <div v-for="(item,index) in dataEstadistics" 
                        :key="item.id" 
                        class="col-12 p-0" >
                    <div class="col-12 d-flex align-items-center border-bottom my-2" >
                        <h3 class="font-weight-bold m-0 mr-3">
                            {{item.percentage}}%
                        </h3>
                        <div 
                            class="rounded-circle m-0 mr-3" 
                            :style="`height:15px;width:15px;background-color:${stadisticsColors[index]}`">
                        </div>
                        <p class="m-0">{{item.name}}</p>
                    </div>
                </div>
                </div>
                <div v-else>
                    <p>
                        No hay registro de información
                    </p>
                </div>
            </div> -->
        </div>
    </b-row>
</div>
</template>

<script>
import { mapState,mapActions } from "vuex";
import PieChart from "@/components/charts/PieChartDetail.js";
export default {
    props: {
        totalAbsenteeism:{},
        time:{},
        justStadistics:Boolean,
    },
    components: {
        PieChart,
    },
    data() {
        return {
          menuStadistics:[],
          stadisticsColors:[
            "#000186", 
            "#C9CAFF",
            "#4E50F3",
            "#5D5FEF",
            "#53BE6B",
            "#8D00A5",
            "#B039CE",
            "#3713C7",
            "#0075FF",
            "#004BD1",  
            "#59A5FF",
            "#1719DA"
        ],
          dataEstadistics:[],
          chartLabels: {},
          chartData: null,
          classItem:''
        }
    },
    computed: {
        ...mapState("modOhAnalyst", [
            "loading",
            "loading2",
            "error",
            "message",
            "employeeInfo",
            "typesAbsenteeism",
            "groupsDiagnostics",
            "diagnostics",
            "riskClassification",
            "listsAbsenteeism",
            "absenteeism",
            "historyAbs"
        ]),
    },
    beforeMount() {
        this.loadStadistics()
    },
    methods: {
        ...mapActions("modOhAnalyst", [
        'actGetEmployeeInfo',
        'actGetTypesAbsenteeism', 
        'actGetGroupsDiagnostics',
        'actGetDiagnostics',
        'actGetRiskClassification',
        'actGetListsAbsenteeism',
        'actSaveAbsenteeism',
        'actGetAbsenteeism',
        'actActAbsenteeism',
        'actGetHistoryOfAbsenteeism'
        ]),
        loadStadistics(){
           this.nameStadistcs = 'Tipos de ausencia'
           this.menuStadistics = [
               {name:'Tipos de ausencia',value:this.totalAbsenteeism.type_absenteeism},
               {name:'Diagnósticos por ausencia',value:this.totalAbsenteeism.diagnosis_cie},
               {name:'Riesgos o Peligros por ausencias',value:this.totalAbsenteeism.risk_classification},
               {name:'Meses con más ausencias',value:this.totalAbsenteeism.months_more_absences},
          ]
            let labelsDetail = []
            let dataDetail = []
            this.dataEstadistics = this.totalAbsenteeism.type_absenteeism
            this.dataEstadistics.forEach(x => {
                labelsDetail.push(x.name)
                dataDetail.push(x.value)
            })
            this.data(labelsDetail,dataDetail)
        },
        changeStadistics(row){
            this.nameStadistcs = row.name
            let labelsDetail = []
            let dataDetail = []
            this.dataEstadistics = row.value
            this.dataEstadistics.forEach(x => {
                labelsDetail.push(x.name)
                dataDetail.push(x.value)
            })
            this.data(labelsDetail,dataDetail)
        },
        data(x,y){
            var extraColors = x.length - this.stadisticsColors.length
            if(extraColors > 0){
                console.log('colores')
                for (let index = 0; index < extraColors; index++) {
                var randomColor = Math.floor(Math.random()*16777215).toString(16);
                this.stadisticsColors.push('#' + randomColor)     
                }
            }
            this.chartData = {
            hoverBorderWidth: 10,
            labels: x,
              datasets: [
                  {
                  backgroundColor: this.stadisticsColors,
                  data: y
                  }
              ]
            }
        },
        selectItem(index){
            this.menuStadistics.forEach(x => {
                if(x.class){
                    x.class = false
                }
            })
            this.menuStadistics[index]['class'] = true
        }
    }

}
</script>

<style lang="scss">
#stadistics{
    .choose{
        color:#454545;
        font-family: Open Sans;
        font-style: italic;
        font-weight: normal;
        font-size: 15px;
    }
    .item{
        cursor: pointer;
        display: flex;
        height: 48px;
        flex-direction: column;
        justify-content: center;
        padding-left: 10px;
        border-left: 4px solid white;
        border-bottom: 1px solid #E9ECEE;
        h3{
            font-weight: 500;
            font-size: 18px;
        }
        p{
            font-size: 14px;
            font-weight: 300;
            margin: 0;
        }
    }
    .item:hover{
        background: var(--main-outline-primary-color);
        border-left: 4px solid var(--main-primary-color);
    }
    .itemSelect{
        background: var(--main-outline-primary-color) !important;
        border-left: 4px solid var(--main-primary-color) !important;
    }
    .cardEstadistics {
        border: 1.0263px solid #F5F5F5;
        border-radius: 25px;
        p{
            font-size: 12px;
        }
    }
    .custom-select{
        padding: 10px 10px;
        font-size: 15px;
        height: 50px;
        border-radius: 10px;
    }
    .btn-create{
        padding: 12px;
        border-radius: 20px;
        background-color: var(--main-primary-color);
        border: none;
        color: white;
        display: flex;
        align-items: center;
        transition: 0.5s;

        span {
            font-size: 30px;
            line-height: 0;
            margin: 0 5px;
            font-weight: 500;
        }
    }
    .btn-create:hover{
        background-color: var(--main-primary-color);
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
    }
    .status{
        padding: 5px 15px;
        border-radius: 20px;
    }
}
</style>